import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      rounded: [
        {
          rounded: [
            'accordion-radius',
            'accordion-trigger-radius',
            'button-sm',
            'button-default',
            'button-lg',
            'button-icon',
            'carousel-arrow-button',
            'partner-card-radius',
            'card-radius',
            'calc-card',
            'bento-card',
            'icon-card',
            'navbar-internal-radius',
            'navbar-primary-button-right-radius',
            'navbar-primary-button-left-radius',
            'navigation-menu-radius',
            'input',
            'popover-radius',
            'hero-halfsize-media-radius',
            'quote-media-radius',
            'contact-section-media-radius',
            'image-text-media-radius',
            'carousel-image-radius',
            'event-detail-media-radius',
            'news-detail-media-radius',
            'content-nav-card',
            'image-gallery-thumbnail',
            'accordion-card-list-media-radius',
            'contact-card-section-media-radius',
            'hero-media-radius',
            'portrait-teaser-media-radius',
            'quote-section-media-radius',
            'location-map-image-rounding',
            'fab-panel',
            'fab-drawer',
            'fab-bar-button',
            'form-embed-media',
          ],
        },
      ],
      'rounded-tr': [
        {
          'rounded-tr': ['footer-top-right-radius', 'navbar-primary-button-right-radius', 'fab-drawer'],
        },
      ],
      'rounded-tl': [
        {
          'rounded-tl': ['footer-top-left-radius', 'navbar-primary-button-left-radius', 'fab-drawer'],
        },
      ],
      'rounded-br': [
        {
          'rounded-br': ['navbar-primary-button-right-radius'],
        },
      ],
      'rounded-bl': [
        {
          'rounded-bl': ['navbar-primary-button-left-radius'],
        },
      ],
      shadow: [
        {
          shadow: [
            'navbar-shadow-ext',
            'navbar-shadow-int',
            'navigation-menu-shadow',
            'carousel-arrow-button-mobile',
            'carousel-arrow-button-desktop',
            'pricing-card',
            'pricing-card-hover',
            'input',
            'card',
            'card-desktop',
            'bento-card',
            'bento-card-desktop',
            'overview-card',
            'overview-card-desktop',
            'overview-card-hover',
            'overview-card-icon',
            'fab-desktop',
            'fab-mobile',
            'fab-neutral-desktop',
            'fab-neutral-mobile',
            'fab-panel-desktop',
            'fab-panel-mobile',
            'fab-mobile-bar',
          ],
        },
      ],
      'font-size': [
        {
          text: [
            // Button mobile (default)
            'button-sm',
            'button-default',
            'button-lg',
            'button-icon',
            // Button desktop (lg:)
            'button-sm-desktop',
            'button-default-desktop',
            'button-lg-desktop',
            'button-icon-desktop',
            'input',
            // Headline mobile (default)
            'h1',
            'h2',
            'h3',
            'h4',
            // Headline desktop (lg:)
            'h1-lg',
            'h2-lg',
            'h3-lg',
            'h4-lg',
            // Copytext
            'body-sm',
            'body-md',
            'body-lg',
            'body-xl',
            // Copytext desktop (lg:)
            'body-sm-lg',
            'body-md-lg',
            'body-lg-lg',
            'body-xl-lg',
            // Accordion
            'accordion-content',
            'accordion-content-lg',
            'accordion-trigger',
            'accordion-trigger-lg',
            'accordion-trigger-active',
            'accordion-trigger-active-lg',
            'accordion-trigger-hover',
            'accordion-trigger-hover-lg',
            'accordion-trigger-hover-active',
            'accordion-trigger-hover-active-lg',
          ],
        },
      ],
      'font-weight': [
        {
          font: [
            // Button mobile (default)
            'button-sm',
            'button-default',
            'button-lg',
            'button-icon',
            // Button desktop (lg:)
            'button-sm-desktop',
            'button-default-desktop',
            'button-lg-desktop',
            'button-icon-desktop',
            'input-default',
            // Headline mobile (default)
            'h1',
            'h2',
            'h3',
            'h4',
            // Headline desktop (lg:)
            'h1-lg',
            'h2-lg',
            'h3-lg',
            'h4-lg',
            // Copytext
            'body-sm',
            'body-md',
            'body-lg',
            'body-xl',
            // Copytext desktop (lg:)
            'body-sm-lg',
            'body-md-lg',
            'body-lg-lg',
            'body-xl-lg',
            // Accordion
            'accordion-content',
            'accordion-content-lg',
            'accordion-trigger',
            'accordion-trigger-lg',
            'accordion-trigger-active',
            'accordion-trigger-active-lg',
            'accordion-trigger-hover',
            'accordion-trigger-hover-lg',
            'accordion-trigger-hover-active',
            'accordion-trigger-hover-active-lg',
            // Standard Tailwind font-weights for correct merging
            'thin',
            'extralight',
            'light',
            'normal',
            'medium',
            'semibold',
            'bold',
            'extrabold',
            'black',
          ],
        },
      ],
      tracking: [
        {
          tracking: [
            // Button mobile (default)
            'button-sm',
            'button-default',
            'button-lg',
            'button-icon',
            // Button desktop (lg:)
            'button-sm-desktop',
            'button-default-desktop',
            'button-lg-desktop',
            'button-icon-desktop',
            'input',
            // Headline mobile (default)
            'h1',
            'h2',
            'h3',
            'h4',
            // Headline desktop (lg:)
            'h1-lg',
            'h2-lg',
            'h3-lg',
            'h4-lg',
            // Copytext
            'body-sm',
            'body-md',
            'body-lg',
            'body-xl',
            // Copytext desktop (lg:)
            'body-sm-lg',
            'body-md-lg',
            'body-lg-lg',
            'body-xl-lg',
            // Accordion
            'accordion-content',
            'accordion-content-lg',
            'accordion-trigger',
            'accordion-trigger-lg',
            'accordion-trigger-active',
            'accordion-trigger-active-lg',
            'accordion-trigger-hover',
            'accordion-trigger-hover-lg',
            'accordion-trigger-hover-active',
            'accordion-trigger-hover-active-lg',
          ],
        },
      ],
      'font-family': [
        {
          font: [
            // Button mobile (default)
            'button-typeface-sm',
            'button-typeface-default',
            'button-typeface-lg',
            'button-typeface-icon',
            // Button desktop (lg:)
            'button-typeface-sm-desktop',
            'button-typeface-default-desktop',
            'button-typeface-lg-desktop',
            'button-typeface-icon-desktop',
            'input-typeface',
            // Headline mobile (default)
            'h1-typeface',
            'h2-typeface',
            'h3-typeface',
            'h4-typeface',
            // Headline desktop (lg:)
            'h1-typeface-lg',
            'h2-typeface-lg',
            'h3-typeface-lg',
            'h4-typeface-lg',
            // Copytext
            'body-sm-typeface',
            'body-md-typeface',
            'body-lg-typeface',
            'body-xl-typeface',
            // Copytext desktop (lg:)
            'body-sm-typeface-lg',
            'body-md-typeface-lg',
            'body-lg-typeface-lg',
            'body-xl-typeface-lg',
            // Accordion
            'accordion-content-typeface',
            'accordion-content-typeface-lg',
            'accordion-trigger-typeface',
            'accordion-trigger-typeface-lg',
            'accordion-trigger-active-typeface',
            'accordion-trigger-active-typeface-lg',
            'accordion-trigger-hover-typeface',
            'accordion-trigger-hover-typeface-lg',
            'accordion-trigger-hover-active-typeface',
            'accordion-trigger-hover-active-typeface-lg',
          ],
        },
      ],
      'bg-color': [
        {
          bg: ['button-outline-background', 'navbar-main-background', 'navbar-int-background', 'overview-card-icon-bg', 'fab-icon-bg', 'overlay-dark', 'overlay-light', 'overlay-scrim', 'overlay-poster', 'overlay-control', 'overlay-control-hover', 'overlay-surface', 'overlay-glass', 'overlay-glass-strong', 'status-online', 'status-offline', 'status-away', 'status-busy', 'banner-warning', 'banner-warning-dark', 'banner-alert', 'banner-alert-dark'],
        },
      ],
      'border-w': [
        {
          border: ['card', 'bento-card', 'button-outline', 'navigation-menu-popover-border'],
        },
      ],
      mt: [
        {
          mt: ['navbar-navigation-menu-popover-padding-y-top'],
        },
      ],
      'min-w': [
        {
          'min-w': ['card', 'content-nav-card-min-w'],
        },
      ],
      'max-w': [
        {
          'max-w': ['page', 'banner-content-max'],
        },
      ],
      'border-color': [
        {
          border: ['overview-card-icon-border', 'calc-green'],
        },
      ],
      pt: [
        {
          pt: ['icon-card-pt', 'icon-card-pt-lg', 'footer-padding-y-top-mobile', 'footer-padding-y-top-desktop'],
        },
      ],
      pb: [
        {
          pb: ['icon-card-pb', 'icon-card-pb-lg', 'fab-safe-bottom', 'safe-bottom', 'footer-padding-y-bottom-mobile', 'footer-padding-y-bottom-desktop'],
        },
      ],
      mb: [
        {
          mb: ['fab-safe-bottom'],
        },
      ],
      pl: [
        {
          pl: ['carousel-item-gap-pl-mobile', 'carousel-item-gap-pl-desktop', 'card-section-pl-mobile', 'card-section-pl-desktop', 'card-carousel-pl-mobile', 'card-carousel-pl-desktop', 'overview-pl-mobile', 'overview-pl-desktop', 'event-bento-pl-mobile', 'event-bento-pl-desktop', 'icon-card-pl', 'icon-card-pl-lg', 'portrait-teaser-gap-mobile', 'portrait-teaser-gap-desktop', 'navbar-int-padding-x-left-mobile', 'navbar-int-padding-x-left-desktop'],
        },
      ],
      pr: [
        {
          pr: ['icon-card-pr', 'icon-card-pr-lg', 'navbar-int-padding-x-right-mobile', 'navbar-int-padding-x-right-desktop'],
        },
      ],
      ml: [
        {
          ml: ['carousel-item-gap-ml-mobile', 'carousel-item-gap-ml-desktop', 'card-section-ml-mobile', 'card-section-ml-desktop', 'card-carousel-ml-mobile', 'card-carousel-ml-desktop', 'overview-ml-mobile', 'overview-ml-desktop', 'event-bento-ml-mobile', 'event-bento-ml-desktop', 'portrait-teaser-ml-mobile', 'portrait-teaser-ml-desktop'],
        },
      ],
      gap: [
        {
          gap: ['card-layout-mobile', 'card-layout-desktop', 'overview-gap-mobile', 'overview-gap-desktop', 'event-bento-grid-gap-mobile', 'event-bento-grid-gap-desktop', 'icon-card', 'icon-card-lg', 'two-column-gap-mobile', 'two-column-gap-desktop', 'pricing-cards-mobile', 'pricing-cards-desktop', 'section-title-gap-lg-mobile', 'section-title-gap-lg-desktop', 'content-nav-gap-mobile', 'content-nav-gap-desktop', 'portrait-teaser-gap-mobile', 'portrait-teaser-gap-desktop'],
        },
      ],
      px: [
        {
          px: ['container-padding-x-mobile', 'container-padding-x-desktop', 'accordion-focus', 'overview-card-px', 'navbar-ext-padding-x-mobile', 'navbar-ext-padding-x-desktop'],
        },
      ],
      py: [
        {
          py: ['section-padding-y-mobile', 'section-padding-y-desktop', 'overview-card-py', 'navbar-ext-padding-y-mobile', 'navbar-ext-padding-y-desktop', 'navbar-int-padding-y-mobile', 'navbar-int-padding-y-desktop'],
        },
      ],
      top: [
        {
          top: ['navbar-ext-padding-y-mobile'],
        },
      ],
      left: [
        {
          left: ['navbar-ext-padding-x-mobile'],
        },
      ],
      right: [
        {
          right: ['navbar-ext-padding-x-mobile'],
        },
      ],

      h: [
        {
          h: ['navbar-primary-button-height', 'input-height', 'button-lg-height', 'fab-mobile-cta'],
        },
      ],
      'max-h': [
        {
          'max-h': ['fab-panel-max-h-mobile', 'fab-panel-max-h-desktop', 'hero-fullscreen'],
        },
      ],
      z: [
        {
          z: ['behind', 'fab', 'mobile-overlay', 'map-popup'],
        },
      ],
      size: [
        {
          size: [
            'carousel-arrow-button-width',
            'carousel-arrow-button-height',
          ],
        },
      ],
      'min-h': [
        {
          'min-h': ['hero-mobile', 'hero-desktop'],
        },
      ],
      w: [
        {
          w: ['logo-width-sm', 'logo-width-md', 'logo-width-lg', 'carousel-arrow-button', 'card-feature-md-2col', 'card-feature-lg-3col', 'card-feature-xl-3col', 'card-feature-lg-4col', 'card-feature-xl-4col'],
        },
      ],
      'backdrop-blur': [
        {
          'backdrop-blur': ['navbar-blur-ext', 'navbar-blur-int', 'navigation-menu-blur', 'fab'],
        },
      ],
      scale: [
        {
          scale: ['fab-hover'],
        },
      ],
      ease: [
        {
          ease: ['fab-drawer'],
        },
      ],
      animate: [
        {
          animate: ['fab-popover-in', 'fab-drawer-in', 'fab-backdrop-in', 'fab-mobile-bar-in', 'fab-mobile-bar-out'],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs));
}

/**
 * Checks if a URL points to an SVG file
 * @param url - The URL to check
 * @returns true if the URL ends with .svg, false otherwise
 */
export function isSvgUrl(url: string): boolean {
  return url.toLowerCase().endsWith('.svg');
}

/**
 * Folds an "empty" string — `''`, `null` or `undefined` — to `undefined`, so
 * callers can default with `??` (which alone would let `''` through). String-only
 * by type, so `0`/`false` can never reach it. UI-layer twin of the mapper helper
 * of the same name (Clean Architecture forbids importing the infra one here).
 */
export function emptyToUndefined(
  value: string | null | undefined
): string | undefined {
  return value === null || value === undefined || value === '' ? undefined : value;
}


